<template>
  <div v-if="devModeOn" class="woo-dev-menu">
    <v-menu offset-y
    :close-on-content-click="false"
      :nudge-width="200"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn small elevation="2" fab
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-bug</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-action>
              <v-switch
                :input-value="playbackRateOn"
                @change="togglePlaybackRate"
                color="purple"
              />
            </v-list-item-action>
          <v-list-item-title>
            Playback Rate
          </v-list-item-title>
        </v-list-item>
        <v-list-item>
          <v-list-item-action>
            <v-switch
              :input-value="remoteCodeVerification"
              @change="toggleRemoteCodeVerification"
              color="purple"
            />
            </v-list-item-action>
          <v-list-item-title>
            Remote Code Verification
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="disableDevMode">
          <v-list-item-title>
            Exit Dev Mode
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import { LOCAL_STORAGE_KEYS } from '@/constants';
export default {
  name: 'DevMenu',
  computed: {
    playbackRateOn() {
      return !!this.$store.state.playbackRateOn;
    },
    devModeOn() {
      return !!this.$store.state.devModeOn;
    },
    remoteCodeVerification() {
      return !!this.$store.state[LOCAL_STORAGE_KEYS.REMOTE_CODE_VERIFICATION];
    }
  },
  methods: {
    disableDevMode() {
      this.$store.commit('devModeOn', false);
    },
    togglePlaybackRate(v) {
      this.$store.commit('playbackRateOn', v);
    },
    toggleRemoteCodeVerification(v) {
      this.$store.commit(LOCAL_STORAGE_KEYS.REMOTE_CODE_VERIFICATION, v);
    },
  },
}
</script>

<style lang="scss" scoped>
  .woo {
    &-dev-menu {
      position: fixed;
      bottom: calc(50% + 50px);
      right: 20px;
      z-index: 1000;
    }
  }
</style>